import { NotificationPanelSecurity } from './notification-panel-security';

export class NotificationPanelResponse {
  securities: NotificationPanelSecurity[] = [];
  count!: number;
}
